/* Hide the 1-års-forbruk-only cadences (Hver 6. / Hver 12. måned) from the
   Appstle product-page widget on the refills 4pk PDP (2026-08-13).

   Those two plans (group "1 års forbruk refills") exist solely for the
   1-year-supply buy box, which adds them via the cart API with 4+ packs.
   Appstle offers no per-plan widget visibility (only customer-tag gating,
   which also blocks purchase), so we prune them client-side here.

   - Scoped by product HANDLE so e.g. the Vareprøve product's own legitimate
     "Hver 6. måned" plan is untouched.
   - Plans are matched by NAME (ids rotate when a plan is edited in Appstle —
     known gotcha) and the matching ids are then used to remove radio entries.
   - If the widget had one of them preselected, selection falls back to the
     first remaining option and a change event lets Appstle re-sync. */
(function () {
  'use strict';
  var HANDLES = ['sape-refills-4pk'];
  var RX = /^Hver (6|12)\.\s*måned$/;

  var m = window.location.pathname.match(/\/products\/([^\/?#]+)/);
  if (!m || HANDLES.indexOf(m[1]) === -1) return;

  function prune() {
    var ids = {};
    document.querySelectorAll('select.appstle_select option').forEach(function (o) {
      if (RX.test(o.textContent.replace(/\s+/g, ' ').trim())) {
        ids[o.value] = true;
        var sel = o.parentElement;
        var wasSelected = o.selected;
        o.remove();
        if (wasSelected && sel && sel.options.length) {
          sel.selectedIndex = 0;
          sel.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });
    document.querySelectorAll('.appstle_subscription_radio_wrapper').forEach(function (w) {
      var input = w.querySelector('input[value]');
      var label = w.textContent.replace(/\s+/g, ' ').trim();
      if ((input && ids[input.value]) || RX.test(label)) {
        if (input && input.checked) {
          var sibling = w.parentElement ? w.parentElement.querySelector('.appstle_subscription_radio_wrapper input[value]:not([value="' + input.value + '"])') : null;
          if (sibling) { sibling.click(); }
        }
        w.style.display = 'none';
      }
    });
  }

  function boot() {
    prune();
    // The widget renders (and re-renders on variant change) asynchronously.
    new MutationObserver(function () { prune(); }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
